import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomSearchResultComponent } from './custom-search-result/custom-search-result.component';
import {
  BreadcrumbModule,
  FacetListModule,
  FacetModule,
  LinkModule,
  MediaModule,
  PaginationModule,
  ProductGridItemComponent,
  ProductListModule,
  SearchBoxModule,
  SortingModule,
  StarRatingModule,
} from '@spartacus/storefront';
import { CustomProductListComponent } from './custom-product-list/custom-product-list.component';
import { I18nModule, UrlModule } from '@spartacus/core';
import { CustomProductListItemComponent } from './custom-product-list-item/custom-product-list-item.component';
import { RouterModule } from '@angular/router';
import { AddToCartModule } from '@spartacus/cart/base/components/add-to-cart';
import { CustomPaginationComponent } from '@shared/custom-pagination/custom-pagination.component';
import { CustomSortingComponent } from '@shared/custom-sorting/custom-sorting.component';

@NgModule({
  declarations: [CustomSearchResultComponent, CustomProductListComponent, CustomProductListItemComponent],
  imports: [
    CommonModule,
    RouterModule,
    CustomPaginationComponent,
    ProductListModule,
    SortingModule,
    BreadcrumbModule,
    FacetListModule,
    FacetModule,
    I18nModule,
    PaginationModule,
    MediaModule,
    StarRatingModule,
    UrlModule,
    AddToCartModule,
    CustomSortingComponent,
  ],
})
export class ComponentsModule {}
